import { Module } from "vuex";

import { AppState } from "../store";

import actions from "./actions";
import mutations from "./mutations";
import { ManipulacaoContextNewState } from "./types";

export type ManipulacaoContextNewGetters = "GET_MANIPULACAO_CONTEXT_NEW";

const manipulacaoContextNew: Module<Map<string, ManipulacaoContextNewState>, AppState> = {
    state: new Map<string, ManipulacaoContextNewState>(),
    actions,
    mutations,
    getters: {
        GET_MANIPULACAO_CONTEXT_NEW: store => (uuid: string) => {
            return store.get(uuid);
        },
    },
};

export default manipulacaoContextNew;
